'use client';

import React, { useEffect, useState } from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

import IconButton from '@cineamo/ui/src/button/IconButton';
import { IconUp24 } from '@cineamo/ui/src/icons/ic-up';

const BackToTop: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    function onBackToTopClick() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    useEffect(() => {
        function handleScroll() {
            if (window.scrollY > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        }
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <IconButton
            icon={IconUp24}
            accessibilityLabel="Back to top"
            onClick={onBackToTopClick}
            classNameButton={cn(
                'fixed right-[56px] bottom-[56px] p-[12px] rounded-full duration-300 z-[100]',
                'bg-[rgba(var(--on-background-color),0.2)] text-[var(--on-background-color)]',
                {
                    'opacity-100 scale-100': isVisible,
                    'opacity-0 scale-0': !isVisible
                }
            )}
        />
    );
};

export default BackToTop;
